import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  all: (siteId: string, includeDisabled?: boolean) =>
    fetchPages<FamilleResponse>(
      'familles',
      `${config.ws.famille.all}?siteId=${siteId}${
        includeDisabled !== undefined ? `&includeDisabled=${includeDisabled}` : ''
      }`,
      'GET'
    ),
}

export default api
